import React from "react";
import useTopic from "@livepix/components/pubsub/useTopic";
import GoalWidgetEmbed from "./GoalWidgetEmbed";
import NotificationWidgetEmbed from "./NotificationWidgetEmbed";
import QRCodeWidgetEmbed from "./QRCodeWidgetEmbed";
import AdvertisementWidgetEmbed from "./AdvertisementWidgetEmbed";
import MarathonWidgetEmbed from "./MarathonWidgetEmbed";
import { Props } from "../Widget";
import RankingWidgetEmbed from "./RankingWidgetEmbed";
import LastTransactionWidgetEmbed from "./LastTransactionWidgetEmbed";
import VideoWidgetEmbed from "./VideoWidgetEmbed";
import PollWidgetEmbed from "./PollWidgetEmbed";

const WidgetEmbed = (props: Props & { widgetId: string }) => {
  useTopic(`user:widgets:${props.userId}`, (message) => {
    switch (message.event) {
      case "reload":
        window.location.reload();
        break;
    }
  });

  if (props.type === "qrcode") {
    return <QRCodeWidgetEmbed {...props} />;
  }

  if (props.type === "goal") {
    return <GoalWidgetEmbed {...props} />;
  }

  if (props.type === "notification" && props.widgetId) {
    return (
      <NotificationWidgetEmbed
        userId={props.userId}
        widgetId={props.widgetId}
      />
    );
  }

  if (props.type === "advertisement") {
    return <AdvertisementWidgetEmbed {...props} />;
  }

  if (props.type === "marathon") {
    return <MarathonWidgetEmbed {...props} />;
  }

  if (props.type === "ranking") {
    return <RankingWidgetEmbed {...props} />;
  }

  if (props.type === "last_transaction") {
    return <LastTransactionWidgetEmbed {...props} />;
  }

  if (props.type === "video" && props.widgetId) {
    return <VideoWidgetEmbed userId={props.userId} widgetId={props.widgetId} />;
  }

  if (props.type === "poll") {
    return <PollWidgetEmbed {...props} />;
  }

  return null;
};

export default WidgetEmbed;
